import _JSON$stringify from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/json/stringify";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _Promise from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/promise";
import { isIos } from "@/utils/lodash";
import { encryptBaseRequest } from "./base";
import * as constants from "./constants";
import { clientError } from "@/api/utils/apiHelper";
import store from "@/store";
import * as types from "@/store/constants/types";
var access_token_value = "";
var refresh_token_value = "";
export var face_get_settings = function face_get_settings() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(resolve, reject) {
      var deviceInfo, result;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              //setting 不需要走任何的token
              deviceInfo = window.device;
              _context.next = 4;
              return encryptBaseRequest(constants.kFaceApiPathSettings, {
                method: "GET",
                params: {
                  platform: deviceInfo.appPlatform
                }
              });

            case 4:
              result = _context.sent;
              console.log("face_get_settings:", result);
              resolve(result);
              _context.next = 14;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              console.log("face_get_settings error:", _context.t0);
              clientError("get_settings", _context.t0);
              reject(_context.t0);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};
/**
 * 返回tokoen值
 */

export var face_login = function face_login() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(resolve, reject) {
      var deviceInfo, result;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              //setting 不需要走任何的token
              deviceInfo = window.device;
              _context2.next = 4;
              return encryptBaseRequest(constants.kFaceApiPathLogin, {
                method: "POST",
                data: {
                  device_id: deviceInfo.deviceId,
                  platform: deviceInfo.appPlatform
                }
              });

            case 4:
              result = _context2.sent;
              console.log("face_login:", result);
              resolve(result);
              _context2.next = 14;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              console.log("face_login error:", _context2.t0);
              clientError("login", _context2.t0);
              reject(_context2.t0);

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }());
};
/**
 * 刷新token
 * @param refreshToken
 */

export var refresh_token = function refresh_token(refreshToken) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(resolve, reject) {
      var result;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return encryptBaseRequest(constants.kFaceApiPathRefreshToken, {
                method: "POST",
                headers: {
                  Authorization: refreshToken
                }
              });

            case 3:
              result = _context3.sent;
              console.log("refresh_token:", result);
              resolve(result);
              _context3.next = 13;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              console.log("refresh_token error:", _context3.t0);
              clientError("refresh_token", _context3.t0);
              reject(_context3.t0);

            case 13:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }());
}; // ALL token

var refreshAlltoken = function refreshAlltoken() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(resolve, reject) {
      var face_login_result;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              console.log("需要refreshAlltoken>>>>>");
              _context4.next = 4;
              return face_login();

            case 4:
              face_login_result = _context4.sent;
              access_token_value = face_login_result.data.access_token;
              refresh_token_value = face_login_result.data.refresh_token;
              resolve();
              _context4.next = 13;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              reject(_context4.t0);

            case 13:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 10]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }());
}; // AT token


var refreshATtoken = function refreshATtoken() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(resolve, reject) {
      var face_login_result;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              console.log("需要refreshATtoken>>>>>");
              _context5.next = 4;
              return refresh_token(refresh_token_value);

            case 4:
              face_login_result = _context5.sent;
              access_token_value = face_login_result.data.access_token;
              resolve();
              _context5.next = 19;
              break;

            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](0);
              console.log("refreshATtoken error:", _context5.t0); //如果AT都过期了

              if (!(_context5.t0.error && typeof _context5.t0.error === "string" && _context5.t0.error.includes("20008"))) {
                _context5.next = 18;
                break;
              }

              _context5.next = 15;
              return refreshAlltoken();

            case 15:
              resolve();
              _context5.next = 19;
              break;

            case 18:
              reject(_context5.t0);

            case 19:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[0, 9]]);
    }));

    return function (_x9, _x10) {
      return _ref5.apply(this, arguments);
    };
  }());
};

export var base_request = function base_request(url, config) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref6 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(resolve, reject) {
      var requestFn;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              requestFn =
              /*#__PURE__*/
              function () {
                var _ref7 = _asyncToGenerator(
                /*#__PURE__*/
                regeneratorRuntime.mark(function _callee6() {
                  var result;
                  return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (config.headers) {
                            config.headers.Authorization = access_token_value;
                          } else {
                            config.headers = {
                              Authorization: access_token_value
                            };
                          }

                          _context6.next = 3;
                          return encryptBaseRequest(url, config);

                        case 3:
                          result = _context6.sent;
                          resolve(result);

                        case 5:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));

                return function requestFn() {
                  return _ref7.apply(this, arguments);
                };
              }();

              _context7.prev = 1;

              if (!(access_token_value === "")) {
                _context7.next = 5;
                break;
              }

              _context7.next = 5;
              return refreshAlltoken();

            case 5:
              _context7.next = 7;
              return requestFn();

            case 7:
              _context7.next = 33;
              break;

            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7["catch"](1);
              //如果收到过期的错误：
              console.log("base_request error:", _context7.t0);
              _context7.prev = 12;

              if (!(_context7.t0.error && typeof _context7.t0.error === "string" && _context7.t0.error.includes("20007"))) {
                _context7.next = 20;
                break;
              }

              _context7.next = 16;
              return refreshATtoken();

            case 16:
              _context7.next = 18;
              return requestFn();

            case 18:
              _context7.next = 28;
              break;

            case 20:
              if (!(_context7.t0.error && typeof _context7.t0.error === "string" && _context7.t0.error.includes("20008"))) {
                _context7.next = 27;
                break;
              }

              _context7.next = 23;
              return refreshAlltoken();

            case 23:
              _context7.next = 25;
              return requestFn();

            case 25:
              _context7.next = 28;
              break;

            case 27:
              reject(_context7.t0);

            case 28:
              _context7.next = 33;
              break;

            case 30:
              _context7.prev = 30;
              _context7.t1 = _context7["catch"](12);
              reject(_context7.t1);

            case 33:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[1, 9], [12, 30]]);
    }));

    return function (_x11, _x12) {
      return _ref6.apply(this, arguments);
    };
  }());
};
export var iap_service = function iap_service(iapData) {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref8 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(resolve, reject) {
      var deviceInfo, device_info, transaction_id, receipt, offer_id, receipt_result, service_result;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              deviceInfo = window.device;
              device_info = {};

              if (isIos()) {
                device_info.idfa = deviceInfo.idfa;
                device_info.idfv = deviceInfo.idfv;
              } else {
                device_info.android_id = deviceInfo.androidId;
                device_info.gaid = deviceInfo.gaid;
              }

              device_info.customer_user_id = deviceInfo.deviceId;
              transaction_id = iapData.transaction_id, receipt = iapData.receipt, offer_id = iapData.offer_id;
              receipt_result = "";

              if (typeof receipt === "string") {
                receipt_result = receipt;
              } else {
                receipt_result = _JSON$stringify(receipt);
              }

              _context8.next = 10;
              return base_request(constants.kFaceApiPathIapService, {
                method: "POST",
                data: {
                  transaction_id: transaction_id,
                  receipt: receipt_result,
                  offer_id: offer_id,
                  device_info: device_info
                }
              });

            case 10:
              service_result = _context8.sent;
              resolve(service_result);
              console.log("iap_service", service_result);
              _context8.next = 21;
              break;

            case 15:
              _context8.prev = 15;
              _context8.t0 = _context8["catch"](0);
              store.commit(types.UPDATE_LOADING_STATUS, false);
              clientError("iap_service", _context8.t0);
              console.log("iap_service error:", _context8.t0);
              reject(_context8.t0);

            case 21:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 15]]);
    }));

    return function (_x13, _x14) {
      return _ref8.apply(this, arguments);
    };
  }());
};
export var iap_service_list = function iap_service_list() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref9 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(resolve, reject) {
      var service_result;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return base_request(constants.kFaceApiPathIapServiceList, {
                method: "GET"
              });

            case 3:
              service_result = _context9.sent;
              console.log("iap_service_list", service_result);
              resolve(service_result);
              _context9.next = 13;
              break;

            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              clientError("iap_service", _context9.t0);
              console.log("iap_service_list error:", _context9.t0);
              reject(_context9.t0);

            case 13:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[0, 8]]);
    }));

    return function (_x15, _x16) {
      return _ref9.apply(this, arguments);
    };
  }());
};
export var user_info = function user_info() {
  return new _Promise(
  /*#__PURE__*/
  function () {
    var _ref10 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee10(resolve, reject) {
      var service_result;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.prev = 0;
              _context10.next = 3;
              return base_request(constants.kFaceApiPathUserInfo, {
                method: "GET"
              });

            case 3:
              service_result = _context10.sent;
              console.log("user_info", service_result);
              _context10.next = 12;
              break;

            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](0);
              clientError("user_info", _context10.t0);
              console.log("user_info error:", _context10.t0);
              reject(_context10.t0);

            case 12:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, null, [[0, 7]]);
    }));

    return function (_x17, _x18) {
      return _ref10.apply(this, arguments);
    };
  }());
};